import { ApolloError, QueryResult, gql, useLazyQuery } from '@apollo/client'
import { optionalEnrollmentId } from '@utils/optionalEnrollmentId'

const HAS_NEXT_AVAILABLE_LESSON = gql`
  query HasNextAvailableLesson($currentLessonId: ID!, $enrollmentId: ID) {
    nextAvailableLesson(
      currentLessonId: $currentLessonId
      enrollmentId: $enrollmentId
    ) {
      id
    }
  }
`

export const useHasNextAvailableLesson = (
  currentLessonId: number,
  /** Ausente na visão do produtor: não existe matrícula. */
  enrollmentId?: number | string | null,
) => {
  const [hasNextAvailableLesson, { loading, error }] = useLazyQuery(
    HAS_NEXT_AVAILABLE_LESSON,
    {
      variables: {
        currentLessonId,
        enrollmentId: optionalEnrollmentId(enrollmentId),
      },
      // A disponibilidade da próxima aula muda quando o aluno conclui a aula
      // atual (progresso linear); cache-first devolveria o resultado antigo.
      fetchPolicy: 'network-only',
    },
  )

  return { hasNextAvailableLesson, loading, error } as {
    hasNextAvailableLesson: (
      currentLessonId: number,
      enrollmentId?: number | string | null,
    ) => Promise<QueryResult<{ nextAvailableLesson: { id: number } }>>
    loading: boolean
    error: ApolloError
  }
}
